import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Resellers from './pages/Resellers';
import Admins from './pages/Admins';
import Licenses from './pages/Licenses';
import CreditManagement from './pages/CreditManagement';
import Transactions from './pages/Transactions';
import Packages from './pages/Packages';
import SMTPSettings from './pages/SMTPSettings';
import AuditLogs from './pages/AuditLogs';
import Profile from './pages/Profile';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="resellers" element={<Resellers />} />
            <Route path="admins" element={<Admins />} />
            <Route path="licenses" element={<Licenses />} />
            <Route path="credits" element={<CreditManagement />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="packages" element={<Packages />} />
            <Route path="smtp-settings" element={<SMTPSettings />} />
            <Route path="audit-logs" element={<AuditLogs />} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Routes>
        <ToastContainer position="top-right" autoClose={3000} />
      </Router>
    </AuthProvider>
  );
}

export default App;
